import styled from 'styled-components';
import bg_01 from '../../assets/images/bg_01.png';

export const Wrapper = styled.div`
  height:100vh;overflow:auto;
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);background:#F7F7F7;
`;

export const Container = styled.div`
  .list{
    display:flex;align-items:center;padding:.33rem .33rem;
    .item{
      display:flex;align-items:center;height: .5rem;margin-right:.66rem; 
      i{
        width:.32rem;height:.32rem;background:#D8D8D8;border-radius:50%;margin: .04rem .18rem 0 0; 
        box-sizing:border-box;display:flex;align-items:center;justify-content:center;
      }
      i.active{
        background:#5799FF;
        b{
          width:.16rem;height:.16rem;border-radius:50%;background:#ffffff;display:block;
        }
      }
      span{
        font-size: .34rem;font-weight: 400;flex:1;color: #000000;
      }
    }
  }
  .title{
    height: .8rem;background: #FFFDEF;font-size: .28rem;font-weight: 400;color: #000000;
    display:flex;align-items:center;justify-content:center;
    span{
      color:#C47070;
    }
  }
  .form{
    padding:0 .33rem;background:#ffffff;
    .item{
      height:1rem;display:flex;box-sizing:border-box;align-items:center;border-top:1px solid #DDDDDD;
      label{
        font-size:.28rem;color:#000000;font-weight:400;margin-right:.4rem;
      }
      input{
        font-size:.28rem;color:#A5AAB2;height:.9rem;font-weight:400;
        border:0px;outline: none;flex:1;color:#000000;
      }
      input::-webkit-input-placeholder{
        color: #9DA1A6;
      }
    }
    .item:first-child{
      border:none;
    }
  }
  .form.form2{
    margin-top:.3rem;
  }
  .btns{
    padding:0 .3rem;
    .btn{
      height: .9rem;background: #5799FF;border-radius: .1rem;font-size: .36rem;font-weight: 400;color: #FFFFFF;margin-top:.6rem;
      display:flex;align-items:center;justify-content:center;
    }
  }
`;